import { render, staticRenderFns } from "./BackgroundUserManagement.vue?vue&type=template&id=24ae55be&scoped=true&"
import script from "./background_user_management.js?vue&type=script&lang=js&"
export * from "./background_user_management.js?vue&type=script&lang=js&"
import style0 from "./BackgroundUserManagement.vue?vue&type=style&index=0&id=24ae55be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ae55be",
  null
  
)

export default component.exports